import { render } from "./SelectProjectCardToPlay.vue?vue&type=template&id=51d1538e&ts=true"
import script from "./SelectProjectCardToPlay.vue?vue&type=script&lang=ts"
export * from "./SelectProjectCardToPlay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__